import { faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector } from "react-redux";
import "./profile.css";
import { useEffect } from "react";
import { Helmet } from "react-helmet";


export const Profile = () => {
    const { user } = useSelector((state) => state.auth);

    return (
        <>
            <Helmet>
                <title>SHOP.CO | Profile - Manage Your Account</title>
                <meta
                    name="description"
                    content="Access and manage your SHOP.CO profile. Update personal details, view order history, and customize your shopping preferences."
                />

                <link
                    rel="canonical"
                    href="https://shop-co-roan.vercel.app/help/customers-support/"
                />

                <meta name="robots" content="noindex, follow" />
            </Helmet>
            <div className="profile-card">
                <form className="profile-form">
                    <h2 className="profile-title">Profile</h2>
                    <div className="profile-div-form">
                        <label className="profile-label" htmlFor="userName">User Name:</label>
                        <input
                            className="profile-input"
                            value={user?.name}
                            disabled="true"
                        />

                        <label className="profile-label" htmlFor="email">Email:</label>
                        <input
                            className="profile-input"
                            value={user?.email}
                            disabled="true"
                        />

                        <label className="profile-label" htmlFor="password">Password:</label>
                        <div className="profile-div-password">
                            <input
                                className="profile-input"
                                value="***********"
                                disabled="true"
                            />
                            <button
                                className="profile-showButton"
                            >
                                <FontAwesomeIcon icon={faEyeSlash} />
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
}